module.exports = __webpack_public_path__ + "static/media/generate-map-packs.aed4ddda.svg";